var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bsp-container"},[_c('BSPHeader'),(!_vm.callActive)?[_c('BSPSetup',{on:{"start-call":_vm.handleStartCall,"call-started":_vm.handleCallStarted}})]:[_c('BSPCall',{attrs:{"is-listening":_vm.isListening,"transcript":_vm.transcript},on:{"end-call":_vm.handleEndCall}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }